<template lang="pug" src="./form-sign-up.pug"></template>

<script>
import api from 'api'
import axios from 'axios'
export default {
  data () {
    return {
      email: '',
      success: false
    }
  },
  methods: {
    submitEmail () {
      axios.post(api + '/rg-mailchimp/subscribe', {
        email: this.email
      })
        .then(e => {
          this.success = true
          this.email = ''
          setTimeout(() => {
            this.success = false
          }, 3000)
        })
        .catch(e => {
          console.log(e)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/form/form-sign-up/form-sign-up.vue